import { Injectable, inject } from '@angular/core';
import {
  AssetService,
  MachineInfo,
  ModalService,
  PlantInfo,
  ToolingInfo,
} from '@schenck/rotec-components';
import { switchMap } from 'rxjs/operators';
import { ToolingTaskInfo } from 'src/api';
import { TaskModalService } from 'src/components';
import { ToolingTaskService } from 'src/services';
import { UpsertToolingTaskWizardComponent } from '../upsert-tooling-task-wizard/upsert-tooling-task-wizard.component';
import { Observable } from 'rxjs';

@Injectable()
export class ToolingTaskModalService extends TaskModalService<ToolingTaskInfo> {
  private readonly assetService = inject(AssetService);

  public tooling$: Observable<ToolingInfo> = this.task$.pipe(
    switchMap((task) => this.assetService.tooling$(task.toolingId))
  );
  public machines$: Observable<MachineInfo[]> = this.assetService.machinesThatHaveTooling$(
    this.tooling$
  );
  public plants$: Observable<PlantInfo[]> = this.assetService.plantsOfTooling$(this.tooling$);

  constructor() {
    const taskService = inject(ToolingTaskService);
    const modalService = inject(ModalService);

    super(taskService, modalService, UpsertToolingTaskWizardComponent);
  }
}
